import { Center, CenterProps } from "@chakra-ui/react";
import { LoadingDots } from "@ui/loading";

export interface ProgressStatCardSkeletonProps extends CenterProps {}

export default function ProgressStatCardSkeleton({
  ...rest
}: ProgressStatCardSkeletonProps) {
  return (
    <Center
      as="dl"
      bgColor="white"
      p="6"
      rounded="lg"
      shadow="md"
      flexDirection="column"
      {...rest}
    >
      <LoadingDots color="currentColor" />
    </Center>
  );
}
